


























import { Component, Mixins, Prop, VModel } from 'vue-property-decorator';

import ModelSetter from "../../../../../../../Mixins/ModelSetter";
import BaseButtonBuilder
  from "../../../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons";
import {
  ButtonBuildersGroups
} from "../../../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import { FileType } from "../../../../../../../components/NewMessageEditors/NewMessageEditorWithMedia/Media/types";
import { MessageEditorWithMediaTab } from "../../../../../../../components/NewMessageEditors/types";
import MultiMessageEditorWithMediaInput from "../../../../../../../components/Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue";
import { VueComponent } from "../../../../../../types/VueComponent";
import { PostMessage } from "../../PostMessage";

@Component({
  data() {
    return {
      MessageEditorWithMediaTab,
    }
  },
  components:{
    MultiMessageEditorWithMediaInput
  }
})
export default class PostActionMessageSetup extends Mixins(ModelSetter) {
  @VModel() postMessage!: PostMessage

  @Prop() disabled!: boolean

  @Prop({ type: Array, default: () => [], required: false }) extraTabs!: Array<MessageEditorWithMediaTab>

  @Prop({ type: Object }) editorSettingsStructure!: any

  @Prop({ type: String, required: true }) mediaUploadTarget!: string

  @Prop({ type: Function }) editorButtonsHelpView!: VueComponent

  @Prop({ type: Array, required: true }) buttons!: Array<BaseButtonBuilder> | Array<ButtonBuildersGroups>

  @Prop({ type: Array, required: false }) blacklistMediaButtonTypes!: Array<FileType>

  get inputSettingsStructure() {
    const defaultSettings = {
      'disable_link_preview': false,
    }

    return Object.assign(defaultSettings, this.editorSettingsStructure)
  }
}
